import { gql } from '@apollo/client';

export const GET_ASSETS_FOR_USER = gql`
  query GetAssetsForUser {
    getAssetsForUser {
      totalAvailableToClaim
      totalAssetsToClaim
      totalAssetsPerWallet
      availableToClaimPerAssetType {
        amountOfAssets
        assetType
        availableToClaim
      }
    }
  }
`;
